import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import { Absolute, Button } from '@rsos/components/capstone/base';

const IMAGE_HEIGHT = '160px';

export const IconBar = styled(Absolute)`
  bottom: 0px;
  left: 0px;
  display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
  flex-direction: row;
  align-items: end;
  width: 100%;
  justify-content: space-between;
  padding: 0 4px 4px;
`;

export const Circle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: red;
`;

export const IconButton = styled(Button).attrs({
  btnType: 'invisible',
  marginY: '0',
  px: '0',
  py: '0',
})`
  height: 16px;
  color: ${({ theme }) => theme.colors.background};

  &:hover {
    background: transparent;

    color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const BlurStopper = styled(Box)`
  overflow: hidden;
`;

export const Preview = styled.img`
  ${({ isBlurred }) => isBlurred && 'filter: blur(20px);'}
  height: ${IMAGE_HEIGHT};
`;

export const Player = styled(Box)`
  display: none;

  &:fullscreen {
    display: inline;
  }
`;

export const FullAbsolute = styled(Absolute).attrs({
  width: '100%',
  top: 0,
  left: 0,
  center: true,
})`
  height: 100%;
`;
